const o = (e) => e.replace(/([A-Z])/g, "-$1").toLowerCase();
export {
  o as camelToKebab
};
//# sourceMappingURL=highrise.es367.js.map
